export default __webpack_public_path__ + "static/media/44t.7f351508.jpg";